import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { Alert, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import dayjs, { TIMEZONE } from "../../utils/dayjs";
import useLocale from "../../utils/useLocale";
import { useGetTransactionQuery } from "./purchaseApi";

export default function PaymentSuccess() {
  const { t } = useTranslation();
  const { locale } = useLocale();

  const [queryParams] = useSearchParams();
  const transactionId = queryParams.get("checkout-transaction-id") ?? "";

  const { data, error } = useGetTransactionQuery({
    transaction_id: transactionId,
  });

  const orderDate = data
    ? dayjs.tz(data.order_date, TIMEZONE).format("D.M.YYYY")
    : null;

  const totalPrice = data
    ? (data.total_price / 100).toLocaleString(locale, {
        style: "currency",
        currency: "EUR",
      })
    : null;

  const validFrom = data?.start_date
    ? dayjs(data.start_date).tz(TIMEZONE)
    : null;
  const validTo = data?.end_date ? dayjs(data.end_date).tz(TIMEZONE) : null;
  return (
    <Stack spacing={3} padding={2}>
      <Stack spacing={2}>
        <Typography variant="h4">
          {t("purchaseParkingPermit.successPage.title")}
        </Typography>
        {error ? (
          <Alert icon={<ErrorOutline fontSize="inherit" />} severity="error">
            {t("purchaseParkingPermit.successPage.error")}
          </Alert>
        ) : (
          <Typography variant="body1">
            {t("purchaseParkingPermit.successPage.description")}
          </Typography>
        )}
      </Stack>
      <Stack spacing={2}>
        <Typography variant="h5">
          {t("purchaseParkingPermit.successPage.orderDetails")}
        </Typography>
        <Stack
          padding={2}
          spacing={2}
          border={1}
          borderColor="divider"
          borderRadius="4px"
          sx={{ backgroundColor: "white" }}
        >
          <Typography variant="body1" data-testid="order-number">
            {t("purchaseParkingPermit.successPage.orderNumber")}: <br />
            <b>{data?.stamp}</b>
          </Typography>
          <Typography variant="body1">
            {t("purchaseParkingPermit.successPage.orderDate")}: <br />
            <b>{orderDate}</b>
          </Typography>
          <Typography variant="body1" data-testid="total-price">
            {t("purchaseParkingPermit.successPage.totalPrice")}: <br />
            <b>{totalPrice}</b>
          </Typography>
          <Typography variant="body1" data-testid="payment-method">
            {t("purchaseParkingPermit.successPage.paymentMethod")}: <br />
            <b>{data?.payment_method}</b>
          </Typography>
          <Typography variant="body1" data-testid="invoicing-address">
            {t("purchaseParkingPermit.successPage.invoicingAddress")}: <br />
            <b>
              {data?.first_name} {data?.last_name} <br />
              {data?.email} <br />
              {data?.phone_number}
            </b>
          </Typography>
        </Stack>
      </Stack>
      <Stack spacing={2}>
        <Typography variant="h5">
          {t("purchaseParkingPermit.successPage.permitDetails")}
        </Typography>
        {data ? (
          <Stack sx={{ backgroundColor: "white" }}>
            <Stack
              direction="row"
              spacing={2}
              padding={2}
              borderColor="divider"
              border={1}
            >
              <Typography variant="h6">{data.product_name}</Typography>
            </Stack>
            <Stack spacing={2} padding={2} border={1} borderColor="divider">
              <Typography variant="body1">
                {t("purchaseParkingPermit.validFrom")} <br />
                <b>{validFrom?.format("LLLL")}</b>
              </Typography>
              {validTo ? (
                <Typography variant="body1">
                  {t("purchaseParkingPermit.validTo")} <br />
                  <b>{validTo.format("LLLL")}</b>
                </Typography>
              ) : null}
            </Stack>
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
}
